export default __webpack_public_path__ + "static/media/dive-chat-demo.cc9cecb4.png";